export enum MarketplaceTypeEnum {
  SHOP = "shop",
}

export default MarketplaceTypeEnum;
